
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emails/[...email-pages]",
      function () {
        return require("private-next-pages/emails/[...email-pages].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emails/[...email-pages]"])
      });
    }
  